import { createTheme, PaletteOptions } from "@mui/material";

// Custom color definitions
const commonColors = {
    // Colors used in both themes
    success: {
        main: '#2e7d32',
        light: '#4caf50',
        dark: '#1b5e20',
    },
    info: {
        main: '#0288d1',
        light: '#03a9f4',
        dark: '#01579b',
    }
};

// Light theme palette
const lightPalette: PaletteOptions = {
    mode: 'light',
    primary: {
        main: '#8C6A2B',
        contrastText: '#ffffff',
    },
    secondary: {
        main: '#9c27b0',
        light: '#ba68c8',
        dark: '#7b1fa2',
        contrastText: '#000000',
    },
    background: {
        default: '#e9e4daff', // Softer beige tone for the background
        paper: '#FDFDFD', // Slightly off-white for cards and containers
    },
    text: {
        primary: '#212121', 
        secondary: '#757575', 
        disabled: '#9E9E9E', 
    },
    error: {
        main: '#d32f2f',
        light: '#ef5350',
        dark: '#c62828',
        contrastText: '#ffffff',
    },
    warning: {
        main: '#c95100',
        light: '#bd3300',
        dark: '#fd6d3c',
    },
    divider: '#E0E0E0', 
    ...commonColors,
};

// Dark theme palette
const darkPalette: PaletteOptions = {
    mode: 'dark',
    primary: {
        main: '#C8A059',
        contrastText: '#000000',
    },
    secondary: {
        main: '#ce93d8',
        light: '#f3e5f5',
        dark: '#ab47bc',
        contrastText: '#ffffff',
    },
    background: {
        default: '#121212',
        paper: '#1e1e1e',
    },
    text: {
        primary: '#ffffff',
        secondary: '#B3B3B3',
        disabled: '#808080',
    },
    error: {
        main: '#e54935',
        light: '#e2584e',
        dark: '#c5382e',
        contrastText: '#000000',
    },
    warning: {
        main: '#ffa826',
        light: '#ffb84d',
        dark: '#e65100',
    },
    divider: '#2F2F2F',
    ...commonColors,
};
export const Theme = createTheme({
    cssVariables: {
        colorSchemeSelector: 'data-toolpad-color-scheme',
    },
    colorSchemes: { 
        light: {
            palette: lightPalette,
        }, 
        dark: {
            palette: darkPalette,
        },
    },
    breakpoints: {
        values: {
            xs: 0,
            sm: 600,
            md: 600,
            lg: 1200,
            xl: 1536,
        },
    },
    typography: {
        fontFamily: [
            '-apple-system',
            'BlinkMacSystemFont',
            '"Segoe UI"',
            'Roboto',
            '"Helvetica Neue"',
            'Arial',
            'sans-serif',
            '"Apple Color Emoji"',
            '"Segoe UI Emoji"',
            '"Segoe UI Symbol"',
        ].join(','),
        h1: {
            fontSize: '2.5rem',
            fontWeight: 600,
        },
        h2: {
            fontSize: '2rem',
            fontWeight: 600,
        },
        h3: {
            fontSize: '1.75rem',
            fontWeight: 600,
        },
        h4: {
            fontSize: '1.5rem',
            fontWeight: 600,
        },
        h5: {
            fontSize: '1.25rem',
            fontWeight: 600,
        },
        h6: {
            fontSize: '1rem',
            fontWeight: 600,
        },
    },
    components: {
        MuiButton: {
            styleOverrides: {
            root: {
                borderRadius: 8,
                textTransform: 'none',
                fontWeight: 500,
            },
            },
        },
        MuiCard: {
            styleOverrides: {
            root: {
                borderRadius: 12,
                boxShadow: '0px 2px 8px #E6E6E6',
            },
            },
        },
    },
});